export const beaconTestContent = (title = '', mode = '') => {
  return `
    <div
      class="b-container b-color-background--0 b-padding-block-end--macro--mini"
    >
      <div class="b-flow-space">
        <h2>h2: ${title}</h2>
        <h3>h3: ${title}</h3>
        <h5 class="b-color-text--title">
          Mode: ${mode || 'none'}
        </h5>
        <p class="b-color-text--error">Error message should be <em>red</em></p>
        <p class="b-color-text--standard">
          Aenean ultricies mi vitae est. Mauris placerat
          eleifend leo. Nam dui mi, tincidunt quis, accumsan porttitor,
          <a href="#" class="b-color-link--standard">Sample link</a>
        </p>
        
      </div>
    </div>
  `;
};

export const basicModernContent = (
  mode = '',
  location = 'light DOM',
  modern = false,
) => {
  let classes = 'b-reset';
  if (modern) {
    classes += ' beacon-theme-modern-outlook';
  }
  if (mode) {
    classes += ` ${mode}`;
  }
  return `<div class="${classes}">
    <h2>H2 in ${location}</h2>
    <ul>
      <li class="b-color-text--error">Error message in ${location}  (should be <em>red</em>)</dd>
      <li>mode?  ${mode || 'none'}</dd>
      <li>modern-outlook?  ${modern}</li>
    </ul>
    <beacon-table variant="fixed">
      <table>
        <thead>
          <tr><th>One</th><th>two</th></tr>
        </thead>
        <tbody>
          <tr><td>three</td><td>four</td></tr>
        </tbody>
      </table>
    </beacon-table>
  </div>`;
};
